import { AiDetectionResult, PolygonEntry } from '@services/concern-detections-service';

// Detection domain types/constants live in the concern-detections service; re-exported
// here so the checkup view keeps a single import point for its constants.
export { ScalpCardState, ScalpSeverity, SCALP_SEGMENT_CLASS } from '@services/concern-detections-service';
export type {
  AiDetectionResult,
  ColoredPolygon,
  PolygonEntry,
  PolygonPointArray,
  ScalpCardCopy,
} from '@services/concern-detections-service';

export type SyntheticPolygonResult = Partial<Omit<AiDetectionResult, 'PolygonPointsSequences'>> & {
  PolygonPointsSequences: PolygonEntry[];
};

export type DisplayDetectionResult = AiDetectionResult | SyntheticPolygonResult;

export type ScalpViewMode = 'outline' | 'filled';

export const TEAL_DETECTION_COLOR = '#4EAE9C';

// Canvas strokes need literal colors (CSS classes don't reach the 2d context).
// Mirrors --cureskin-mint-300 in styles.css.
export const HAIRLINE_DETECTED_COLOR = '#70FFE8';
export const HAIRLINE_WHITE_COLOR = '#ffffff';
